import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/(protected)/workspaces/$workspaceId/sops/'
)({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/workspaces/$workspaceId',
      params: { workspaceId: params.workspaceId },
    })
  },
  component: () => null,
})
